import { render, staticRenderFns } from "./MedecinDetail.vue?vue&type=template&id=66c1c4a3&"
import script from "./MedecinDetail.vue?vue&type=script&lang=js&"
export * from "./MedecinDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports